import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { userSelector } from "redux/modules/_TODO/auth";

import { approveHandbookTemplate } from "pages/HandBook/model/thunks";
import { IHandbookTemplateApprovalStep } from "pages/HandBook/model/types";

import { useTypedSelector } from "app/store/typedUseSelector";
import ApprovingCell from "entities/ApprovingCell/ApprovingCell";

import { generateStorageKey } from "utils/helpers/generateStorageKey";

interface HandBookTemplateApprovingCell {
  approvals: IHandbookTemplateApprovalStep[];
  templateId: number;
}

const HandBookTemplateApprovingCell: React.FC<HandBookTemplateApprovingCell> = ({ approvals, templateId }) => {
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const key = generateStorageKey({ id: templateId, type: "approveHandbookTemplate" });
  const isPending = useTypedSelector((state) => state.handBookReducer.loadings)[key];

  const approve = () => dispatch(approveHandbookTemplate(templateId));

  if (!approvals?.length) return null;

  return <ApprovingCell currentUserId={user.id} approvals={approvals} approve={approve} isPending={isPending} />;
};

export default React.memo(HandBookTemplateApprovingCell);
